import React, { useContext } from 'react'
import DiagnosticImage from '@BUP/assets/Images/Data/diagnostic_image.svg'
import SociogramImage from '@BUP/assets/Images/Data/sociogram_image.svg'
import QuienesResponden from '@BUP/assets/Images/Data/data_¿quienes-responden.svg'
import Duracion from '@BUP/assets/Images/Data/data_¿duracion.svg'
import QueMide from '@BUP/assets/Images/Data/data_¿que-mide.svg'
import { useTranslation } from 'react-i18next'
import { isSociogram } from '@BUP/services/BraveUp'
import { useHistory } from 'react-router-dom'
import styles from './data-page-teacher.module.scss'
import PageLayout from '@BUP/components/Layout/Page'
import BupSpinner from '@BUP/components/Loading/Spinner'
import InstrumentCard from '@BUP/components/Generics/Cards/InstrumentCard'
import InfoCard from '@BUP/components/Generics/Cards/InfoCard'
import InfoCardItem from '@BUP/components/Generics/Cards/InfoCardItem'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'
import { useGetCurrentSociogram } from '@BUP/hooks/Sociogram/useGetCurrentSociogram'

const DataPageTeacher = () => {
  const [t] = useTranslation()
  const organization = useContext(OrganizationContext)
  const organizationId = organization && organization.id
  const history = useHistory()
  const { isLoading: isLoadingCurrentSociogram, dataCurrentSociogram } =
    useGetCurrentSociogram(organizationId)
  const currentSociogram =
    dataCurrentSociogram && dataCurrentSociogram.currentSociogram

  return (
    <PageLayout pageName='BRAVE UP! DATA'>
      {isLoadingCurrentSociogram
        ? (
          <BupSpinner size='large' />
          )
        : (
          <>
            <p className={styles.intro_text}>
              {t('pages.data.instruments.introTextTeacher')}
            </p>
            <div className={styles.instruments_container}>
              <InstrumentCard
                srcImage={SociogramImage}
                title={t('pages.data.instruments.sociogramTitle')}
                description={t(
                  'pages.data.instruments.sociogramDescriptionTeacher'
                )}
                isClickeable={isSociogram(organization) && currentSociogram}
                onClick={() => history.push('/sociogram')}
                imageHasPadding
              />
              <InfoCard title={t('pages.data.instruments.sociogramTitle')}>
                <InfoCardItem
                  img={Duracion}
                  title={t('pages.data.instruments.durationTitle')}
                  description={t('pages.data.instruments.durationDescriptionECE')}
                />
                <InfoCardItem
                  img={QuienesResponden}
                  title={t('pages.data.instruments.whoCanAnswerTitle')}
                  description={t(
                    'pages.data.instruments.whoCanAnswerDescriptionTeacher'
                  )}
                />
                <InfoCardItem
                  img={QueMide}
                  title={t('pages.data.instruments.whatMeasuresTitle')}
                  description={t(
                    'pages.data.instruments.whatMeasuresDescriptionECE'
                  )}
                />
              </InfoCard>
              <InstrumentCard
                srcImage={DiagnosticImage}
                title={t('pages.data.instruments.diagnosticTitle')}
                description={t(
                  'pages.data.instruments.diagnosticDescriptionTeacher'
                )}
              />
              <InfoCard title={t('pages.data.instruments.diagnosticTitle')}>
                <InfoCardItem
                  img={Duracion}
                  title={t('pages.data.instruments.durationTitle')}
                  description={t('pages.data.instruments.durationDescriptionECE')}
                />
                <InfoCardItem
                  img={QuienesResponden}
                  title={t('pages.data.instruments.whoCanAnswerTitle')}
                  description={t(
                    'pages.data.instruments.whoAnswerDescriptionTeacher'
                  )}
                />
                <InfoCardItem
                  img={QueMide}
                  title={t('pages.data.instruments.whatMeasuresTitle')}
                  description={t(
                    'pages.data.instruments.whatMeasuresInstrumentDescriptionTeacher'
                  )}
                />
              </InfoCard>
            </div>
          </>
          )}
    </PageLayout>
  )
}
export default DataPageTeacher
